/**
 * Read an auth-related key from sessionStorage or localStorage (session first).
 * Use this so auth persists when opening the app in a new tab (localStorage is shared).
 */
export function getAuthItem(key) {
  return sessionStorage.getItem(key) || localStorage.getItem(key);
}

/**
 * Get parsed auth object from session or local storage.
 */
export function getAuth() {
  const raw = getAuthItem("auth");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
